import { render, staticRenderFns } from "./PathwayCU.vue?vue&type=template&id=197d0b94"
import script from "./PathwayCU.vue?vue&type=script&lang=js"
export * from "./PathwayCU.vue?vue&type=script&lang=js"
import style0 from "./PathwayCU.vue?vue&type=style&index=0&id=197d0b94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports